var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-component-container"},[_c('div',{ref:"map",staticClass:"map-component"})])
}
var staticRenderFns = []

export { render, staticRenderFns }